/**
 * WARNING: This file was auto-generated by svgr. Do not edit.
 */
import * as React from 'react'
import type { SVGProps } from 'react'
/**
 * @internal
 */
const SvgMediaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2h16v12H4z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M9.5 8.5a.5.5 0 0 1 .8-.4l5 3.75a.5.5 0 0 1 0 .8l-5 3.75a.5.5 0 0 1-.8-.4z"
    />
  </svg>
)
export default SvgMediaIcon
